query allHockeyTeams(
  $first: Int,
  $offset: Int,
  $filter: HockeyTeamFilter,
  ) {
  teams: allHockeyTeams(
      first: $first,
      offset: $offset,
      filter: $filter
    ) {
    nodes {
        squad
        shortName
        name
        source
        teamId
        division
        stadium
        city
        state
        mappings: hockeyTeamMappingsByIntId {
        nodes {
          extId
          extRef
          feed
          mappingType
        }
      }
    }
    totalCount
  }
}
